/** Modules de l'application — utilisés par la matrice RBAC (US-ADM-03) */
export const MODULES = [
  'dashboard',
  'administration',
  'personnels',
  'notifications',
  'batiments',
  'equipements',
  'services',
  'interventions',
  'reporting',
] as const;

export type Module = (typeof MODULES)[number];

/** Actions RBAC autorisées sur un module */
export const ACTIONS = ['create', 'read', 'update', 'delete', 'manage'] as const;

export type Action = (typeof ACTIONS)[number];
